import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import partsRow from "./Plugin/partsRowTable.vue";
import moment from "moment";
import { processApi } from "../../../../utility/index"

export default {
    components: { iTable, IPagination, partsRow },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                maintainState: '',
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "workTime",
                    label: this.$t('VehicleManagement.workTime'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "nextMaintainTime",
                    label: this.$t('VehicleManagement.nextMaintainTime'),
                    align: "center",
                    width: "220px"
                },

                {
                    prop: "maintainCycle",
                    label: this.$t('VehicleManagement.maintainCycle'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "maintainReminder",
                    label: this.$t('VehicleManagement.maintainReminder'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "lastMaintainTime",
                    label: this.$t('VehicleManagement.lastMaintainTime'),
                    align: "center",
                    width: "220px"
                },
                {
                    prop: "isMaintainOver",
                    label: this.$t('VehicleManagement.state'),
                    align: "center",
                    width: "120px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.isMaintainOver === '' ? '' : params.row.isMaintainOver === 0 ? 'success' : params.row.isMaintainOver === 1 ? 'warning' : 'danger' }
                        }, params.row.isMaintainOver === '' ? '' : params.row.isMaintainOver === 0 ? this.$t('common.normal') : params.row.isMaintainOver === 1 ? this.$t('common.nearTime') : this.$t('common.exceedTime'))
                    }

                }
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                carId: [
                    { required: true, message: this.$t('VehicleManagement.form.imputCarid'), trigger: 'blur' },
                ],
                operateUser: [
                    { required: true, message: this.$t('VehicleManagement.form.imputMaintainPerson'), trigger: 'blur' }
                ],
                operateTime: [
                    { required: true, message: this.$t('VehicleManagement.form.chooseMaintainTime'), trigger: 'change' }
                ],
            },
            form: {
                carId: '',
                operateUser: '',
                operateTime: '',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                Cost: '',
                filePath: '',
                maintainProject: '',
                maintainPropose: ''
            },
            selected: [],
            orgId: '',
            imageUrl: '',
            dialogVisible: false,
            processImg: processApi,
            FileList: [],
            filePath: '',
            dialogProjectFormVisible: false,
            tableData: [],
            projectOption: '',
            btnName: "选择项目",
            maintainProject: ''
        }
    },
    computed: {
        materialCost() {
            this.form.materialCost = Number(this.form.Cost || 0)
            return this.form.materialCost
        },
    },
    watch: {
        materialCost(val) {
            this.form.materialCost = val
        },
    },
    methods: {
        computedPrice(num) {
            console.log(num)
            this.form.Cost = num
        },
        getReminderList() {
            let param = {
                orgId: this.orgId,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                maintainState: this.formInline.maintainState,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('MaintenanceManagement/GET_QUERYREMINDERLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        res.data.data.list.map(item => {
                            item.nextMaintainTime = item.nextMaintainTime ? moment(item.nextMaintainTime).format("YYYY-MM-DD") : ''
                            item.lastMaintainTime = item.lastMaintainTime ? moment(item.lastMaintainTime).format("YYYY-MM-DD") : ''
                        })
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getReminderList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                maintainState: '', 
            }
            this.getReminderList()
        },
        addReminder() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.form.carId = this.selected[0].carId
            this.form.operateUser = sessionStorage.getItem("username")
            this.form.operateTime = moment().format("YYYY-MM-DD HH:mm:ss")
            this.form.filePath = ''
            this.btnName = "选择项目"
            this.FileList = []
            this.$nextTick(() => {
                this.$refs.diaTable.tableData = []
                this.$refs.form.clearValidate()
            })
        },
        handlePictureCardPreview(file) {
            this.imageUrl = file.url;
            this.dialogVisible = true;
        },
        handleRemove(file, fileList) {
            this.FileList = []
            const arr = []
            fileList.map((item) => {
                this.FileList.push({
                    name: item.name,
                    url: item.url,
                    uid: item.uid
                })
                arr.push(item.url)
            })
            this.form.filePath = arr.join(',')
        },

        handleAvatarSuccess(res, file) {
            const arr = []
            this.FileList.push({
                url: res[0],
            })
            this.FileList.map(item => {
                arr.push(item.url)
            })
            this.form.filePath = arr.join(',')
        },
        beforeUpload(file) {
            console.log(file)
            let acceptList = ["jpg", "png", "pdf"]
            let fileType = file.name.split('.').pop().toLowerCase()
            if (acceptList.indexOf(fileType) === -1) {
                this.$message.error('只能上传 pdf/jpg/png 格式的文件 !');
                return false
            }

            // if (file.size / 1024 / 1024 > 1) {
            //     this.$message.error('上传文件大小不能超过 1M !');
            //     return false
            // }
        },
        changeProject() {
            this.dialogProjectFormVisible = true
            this.getProjectList()

            // this.form.maintainProject
        },
        indexMethod(index) {
            return index + 1;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let columnArr = [0]
            let projectbArr = [];
            for (let k in this.tableData) {
                projectbArr.push(this.tableData[k].project)
            }
            let obj = {}
            for (let i = 0; i < projectbArr.length; i++) {
                if (obj[projectbArr[i]] == undefined) {
                    obj[projectbArr[i]] = 1
                } else {
                    obj[projectbArr[i]]++
                }
            }
            let spanArr = [];
            let doneArr = []
            for (let i = 0; i < projectbArr.length; i++) {
                if (doneArr.includes(projectbArr[i])) {
                    spanArr.push(0)
                } else {
                    spanArr.push(obj[projectbArr[i]])
                    doneArr.push(projectbArr[i])
                }
            }
            if (columnArr.includes(columnIndex)) {
                for (let i = 0; i < spanArr.length; i++) {
                    if (rowIndex == i) {
                        return {
                            rowspan: spanArr[i],
                            colspan: 1
                        }
                    }
                }
            }
        },
        getProjectList() {
            this.$store.dispatch('MaintenanceProgram/GET_SELECTPROJECT', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.tableData = res.data.data
                    }
                }
            }).catch(err => { })
        },
        changeRadio(index,row) {
            this.tableData.map(item => {
                if (item.projectName == row.projectName) {
                    row.projectOption = index
                }
            })
            let arr = []
            arr.push({
                projectId: row.id,
                projectOption: row.projectOption
            })
            this.maintainProject = arr.concat(this.maintainProject)
        },
        submitProject() {
            let filteredArr = this.maintainProject.filter(function (obj) {
                return Object.keys(obj).length > 0;
            });
            if (filteredArr.length > 0) {
                this.btnName = filteredArr.length + "个项目"
            } else {
                this.btnName = "选择项目"
            }
            this.form.maintainProject = filteredArr
            this.dialogProjectFormVisible = false
            this.maintainProject = []
        },
        cancleProject() {
            this.dialogProjectFormVisible = false
        },
        closeProjectDia() {
            this.dialogProjectFormVisible = false
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        carId: this.form.carId,
                        operateUser: this.form.operateUser,
                        operateTime: this.form.operateTime,
                        remarks: this.form.remarks,
                        peopleCost: this.form.peopleCost,
                        filePath: this.form.filePath,
                        maintainMaterialList: JSON.stringify(this.$refs.diaTable.tableData),
                        maintainProject: JSON.stringify(this.form.maintainProject),
                        maintainPropose: this.form.maintainPropose,
                        materialCost: this.form.materialCost
                    }
                    this.$store.dispatch('MaintenanceManagement/GET_INSERTREMINDER', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.addSuccess'))
                            this.dialogFormVisible = false;
                            this.getReminderList();
                            this.closeDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                carId: '',
                operateUser: '',
                operateTime: '',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                filePath: ''
            }
        },
        closeDia() {
            this.form = {
                carId: '',
                operateUser: '',
                operateTime: '',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                filePath: ''
            }
            this.dialogFormVisible = false;
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getReminderList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}